module.exports = __webpack_public_path__ + "img/1df66be.jpg";